import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    CertificateCreate: lazyLoad(async () => {
        const { CertificateCreate } = await import('./EditCertificates');

        return { default: CertificateCreate };
    }),
    CertificateEdit: lazyLoad(async () => {
        const { CertificateEdit } = await import('./EditCertificates');

        return { default: CertificateEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-certificates.title-add',
        page: lazy.CertificateCreate,
        path: route.patterns.individualUser.certificates.create,
    },
    {
        documentTitle: 'pages.user-certificates.title-edit',
        page: lazy.CertificateEdit,
        path: route.patterns.individualUser.certificates.edit,
    },
];
